/**
 * Utility function to add CSS code to the document `<head>`
 * @param styleString - CSS string to add
 */
export default function addStyle(styleString) {
    const style = document.createElement('style');
    style.textContent = styleString;
    document.head.append(style);
}
